import React from 'react'

import { useSessionPermission } from '@btime/react-session'
import FixedRoundButton from '../../../components/actions/FixedRoundButton'
import { useOpenStocksModal } from '../../../utils/routes/modals/modalsActions'

const AddNewButton = () => {
  const hasAddPermission = useSessionPermission('createStocks')
  const openStocks = useOpenStocksModal()

  if (!hasAddPermission) return false

  return <FixedRoundButton onClick={openStocks} />
}

export default AddNewButton
